module.exports = __webpack_public_path__ + "img/ch17_10_历史馆.7086fc95.jpg";